import { render, staticRenderFns } from "./mine-balance-recharge.vue?vue&type=template&id=f38aa8a4&scoped=true&"
import script from "./mine-balance-recharge.vue?vue&type=script&lang=js&"
export * from "./mine-balance-recharge.vue?vue&type=script&lang=js&"
import style0 from "./mine-balance-recharge.vue?vue&type=style&index=0&id=f38aa8a4&prod&lang=scss&"
import style1 from "./mine-balance-recharge.vue?vue&type=style&index=1&id=f38aa8a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f38aa8a4",
  null
  
)

export default component.exports